var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8693 8.94336H7.54026C3.37565 8.94336 0 12.319 0 16.4836C0 20.6482 3.37565 24.0239 7.54026 24.0239H7.79111V31.022C7.79111 31.142 7.93677 31.2027 8.02173 31.1178L15.1142 24.0252H42.8693C47.0339 24.0252 50.4096 20.6496 50.4096 16.485C50.4096 12.3204 47.0339 8.94336 42.8693 8.94336Z",
    fill: "#2B71F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7496 51.0566H53.448C57.0668 51.0566 60 48.1234 60 44.5047C60 40.8859 57.0668 37.9527 53.448 37.9527H32.2301V31.8719C32.2301 31.7676 32.1035 31.7148 32.0297 31.7887L25.8668 37.9516H22.7496C19.1309 37.9516 16.1977 40.8848 16.1977 44.5035C16.1977 48.1223 19.1309 51.0566 22.7496 51.0566Z",
    fill: "#4FB5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/1-1.ef1beb72ca3a17699d5e0a2066b94bda.svg";
export { ForwardRef as ReactComponent };